import { getCurrentInstance } from 'vue';

export default function useAnalytics() {
  return getCurrentInstance().appContext.config.globalProperties?.$analytics || {track: () => {}};
}
